import type { ElementRef } from "react";
import React, { forwardRef } from "react";

export const View = forwardRef<
  ElementRef<"div">,
  React.HTMLAttributes<HTMLDivElement>
>(({ ...props }, ref) => {
  return <div {...props} ref={ref} />;
});
